// 火狐  拖拽 阻止 冒泡
export function dragDrop(ev: any): void {
  ev.stopPropagation();
  ev.preventDefault();
  ev.dataTransfer = ev.originalEvent.dataTransfer;
}
